<a id="filter-link" class="filter-link" (click)="toggleDatableSidebar()" [ngClass]="{ active: globalData.applicationState.datatableSidebarOpen }">
    <mat-icon svgIcon="filter"></mat-icon>
</a>
